import React from 'react';

import CustomSpinner, { CustomSpinnerColor } from '@components/Spinner/CustomSpinner';
import SuggestedAiPromptCard from '@components/SuggestedAiPromptCard';
import { SuggestedAiPromptCardAs } from '@components/SuggestedAiPromptCard/constants';
import useEventTracking from '@hooks/useEventTracking';
import { useSuggestedAiPrompts } from '@hooks/useSuggestedAiPrompts';
import { ClickTarget, TrackingLocation, click } from '@tracking';
import { DEEP_RESEARCH_HELP_EMAIL } from '@utils/constants';

const Help = (): JSX.Element => {
  const { Track, trackEvent } = useEventTracking({
    location: TrackingLocation.Help,
  });
  const { isLoadingSuggestedAiPrompts, suggestedAiPrompts } = useSuggestedAiPrompts();

  const handleEmailClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.AnchorLink, clickText: DEEP_RESEARCH_HELP_EMAIL }));
  };

  return (
    <Track>
      <div id="help">
        <h2 className="mb-6 font-suisse-works text-headline-xxs">Help</h2>
        <div className="border-0 border-b border-t border-solid border-grayscale-beige">
          <p className="font-suisse-intl text-description-sm">
            For Deep Research problems, please contact{' '}
            <a
              className="underline"
              href={`mailto:${DEEP_RESEARCH_HELP_EMAIL}`}
              onClickCapture={handleEmailClick}
            >
              {DEEP_RESEARCH_HELP_EMAIL}
            </a>
            .
          </p>
        </div>

        <div>
          <p className="font-suisse-intl text-description-sm">
            AI Research is trained on The Information’s exclusive reporting and data. Here are some
            sample research topics to guide your queries.
          </p>
        </div>
        <div className="my-24">
          {isLoadingSuggestedAiPrompts ? (
            <div className="mx-auto mt-8 pt-16">
              <CustomSpinner size={10} color={CustomSpinnerColor.PrimaryMagenta} />
            </div>
          ) : (
            <div className="grid grid-cols-2 gap-24">
              {suggestedAiPrompts.map((suggestion, index) => (
                <SuggestedAiPromptCard
                  key={index}
                  as={SuggestedAiPromptCardAs.Anchor}
                  disablePrompts={false}
                  suggestedAiPrompt={suggestion}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </Track>
  );
};

export default Help;
